import React from "react";

const Google = () => {
  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 1024 1024"
    
    >
      <path
        className="rui-4K4Y7 _3Z_D3"
        d="M520.579 450.924c-0.101 48.468 0 96.885 0.403 145.604 82.808 2.62 165.919 1.36 248.928 2.62-36.77 180.217-286.857 238.761-419.279 120.867-136.049-103.283-129.501-329.902 11.887-425.678 98.826-77.588 239.509-58.393 338.335 8.666 39.037-35.217 75.303-73.004 110.612-112.1-82.304-64.237-183.296-110.186-290.886-105.198-224.045-7.507-430.31 185.003-434.088 404.82-14.355 179.814 106.331 356.151 276.43 419.481 169.646 64.086 386.992 20.506 495.187-128.777 71.374-94.466 86.838-215.787 78.527-329.902-138.819-1.108-277.538-0.907-416.056-0.403z"
      ></path>
    </svg>
  );
};

export default Google;
